export default __webpack_public_path__ + "static/media/wayfarer1line.2facd9c3.png";